import React from 'react';

interface RedoIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const RedoIcon: React.FC<RedoIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  className,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.06-5.5 7.6-5.5 1.96 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" fill={fill} />
  </svg>
);

export default RedoIcon;
